import React from "react";
import PropTypes from "prop-types";
import { Dropdown, Input } from "@boozallen-uip/uswds-react-core";
import {
  FormField,
  FormFieldBody,
  FormFieldContainer,
  FormSectionContainer,
  FormSectionHeader,
  FormSectionHeaderContainer,
  FormSectionSubHeader,
} from "../../shared.styled";
import { formatPhoneNumber } from "../utils/productFormValidation";

export default function ProductPocSection({
  productPoc,
  setProductPoc,
  clearFieldErrors,
  getFieldError,
  renderInlineFieldError,
  FormFieldRequired,
  stateLabelValues,
}) {
  return (
    <FormSectionContainer className="col-span-8">
      <FormSectionHeaderContainer>
        <FormSectionHeader>Product point of contact (POC) information</FormSectionHeader>
        <FormSectionSubHeader>Provide a POC for any questions around this specific product and/or its ACR.</FormSectionSubHeader>
      </FormSectionHeaderContainer>
      <FormFieldContainer>
        <FormFieldBody>
          <FormField className="col-start-1">
            <Input
              id="productPocPhone"
              value={productPoc.phoneNumber ?? ""}
              placeholder="202-555-1212"
              maxLength={12}
              onChange={(e) => {
              clearFieldErrors(["productPoc.phoneNumber"]);
              setProductPoc({ ...productPoc, phoneNumber: formatPhoneNumber(e.target.value) });
              }}
            >
              Phone number <FormFieldRequired />
            </Input>
            {renderInlineFieldError(getFieldError("productPoc.phoneNumber"))}
          </FormField>
          <FormField>
            <Input id="productPocEmail" value={productPoc.email ?? ""} placeholder="name@example.com" onChange={(e) => {
              clearFieldErrors(["productPoc.email"]);
              setProductPoc({ ...productPoc, email: e.target.value });
            }}>
              Email address <FormFieldRequired />
            </Input>
            {renderInlineFieldError(getFieldError("productPoc.email"))}
          </FormField>

          <FormField className="col-start-1">
            <Input id="productPocStreet1" value={productPoc.street1 ?? ""} onChange={(e) => setProductPoc({ ...productPoc, street1: e.target.value })}>
              Street Address Line 1
            </Input>
          </FormField>
          <FormField>
            <Input id="productPocStreet2" value={productPoc.street2 ?? ""} onChange={(e) => setProductPoc({ ...productPoc, street2: e.target.value })}>
              Street Address Line 2
            </Input>
          </FormField>

          <FormField className="col-start-1">
            <Input id="productPocCity" value={productPoc.city ?? ""} onChange={(e) => setProductPoc({ ...productPoc, city: e.target.value })}>
              City
            </Input>
          </FormField>
          <FormField>
            <Dropdown id="state"
              optionRenderer={(o) => o.label}
              options={stateLabelValues}
              comparator={(value, option) => value.value === option}
              value={productPoc.state ?? null}
              onChange={e => setProductPoc({ ...productPoc, state: e.detail.value.value })}>
              State
            </Dropdown>
          </FormField>
          <FormField className="col-start-1">
            <Input id="productPocZipCode" value={productPoc.zipCode ?? ""} onChange={(e) => {
              clearFieldErrors(["productPoc.zipCode"]);
              setProductPoc({ ...productPoc, zipCode: e.target.value });
            }}>
              ZIP Code
            </Input>
            {renderInlineFieldError(getFieldError("productPoc.zipCode"))}
          </FormField>
        </FormFieldBody>
      </FormFieldContainer>
    </FormSectionContainer>
  );
}

ProductPocSection.propTypes = {
  productPoc: PropTypes.object.isRequired,
  setProductPoc: PropTypes.func.isRequired,
  clearFieldErrors: PropTypes.func.isRequired,
  getFieldError: PropTypes.func.isRequired,
  renderInlineFieldError: PropTypes.func.isRequired,
  FormFieldRequired: PropTypes.elementType.isRequired,
  stateLabelValues: PropTypes.array.isRequired,
};
